import React, { useState, useEffect } from 'react'
import NewSchoolStyle from './NewSchoolsOrganizationPage.module.css'
import AdminHeader from '../../components/Header/AdminHeader'
import AdminSideBar from '../../components/SideBar/AdminSideBar'
import { FaCloudArrowUp } from "react-icons/fa6";
import { FiTrash2 } from "react-icons/fi";
import { Link } from 'react-router-dom';
import AdminFooter from '../../components/Footer/AdminFooter'
import BackBar from '../../components/BackBar/BackBar';
import Swal from "sweetalert2";
import { useNavigate } from 'react-router-dom';
import { DatePicker } from 'rsuite';
import DataTable from 'react-data-table-component';
import axios from "axios";

export default function NewSchoolsOrganizationPage() {
  const [schools, setSchools] = useState([]);
  const [filteredSchools, setFilteredSchools] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedDate, setSelectedDate] = useState('');
  const [searchTerm, setSearchTerm] = useState("");

  const navigate = useNavigate();
  useEffect(() => {
    // Fetch the data from your PHP API
    const fetchSchools = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}authormeetapi/get_cordinator_school_data.php`);
        const data = await response.json();
        if (data.success) {
          setSchools(data.users);
          setFilteredSchools(data.users);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchSchools();
  }, []);

  if (isLoading) {
    return <div></div>; // Show loading state while fetching data
  }

  const handleSendContract = async (cordinatorId) => {
    try {
      //setSendingId(cordinatorId);

      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}authormeetapi/send_contract.php`,
        { cordinator_id: cordinatorId },
        { headers: { 'Content-Type': 'application/json' } }
      );

      if (response.data.success) {
        Swal.fire({
          icon: 'success',
          title: 'Contract Sent',
          text: 'The contract has been sent successfully.',
          timer: 2000,
          showConfirmButton: false,
        });
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Failed',
          text: response.data.message || 'Failed to send contract.',
        });
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Something went wrong while sending the contract.',
      });
    } finally {
      //setSendingId(null);
    }
  };

  const handleActivate = async (schoolId) => {

    // Show confirmation popup
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Do you want to activate this school?",
      icon: "info",
      showCancelButton: true,
      confirmButtonText: "Yes, activate it!",
      cancelButtonText: "Cancel",
    });

    if (!result.isConfirmed) return;

    try {
      // Make the API call to activate the school

      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}authormeetapi/get_cordinator_school_data.php?school_activate=${schoolId}`);
      const data = await response.json();
      if (data.success) {
        await handleSendContract(schoolId);
        Swal.fire({
          title: "Activation Successful!",
          text: "Redirecting to your activated schools!.",
          icon: "success",
          timer: 2500, // Pop-up duration in milliseconds
          showConfirmButton: false, // No need for a confirmation button
        }).then(() => {
          // Redirect after pop-up
          navigate(`/ActivatedSchoolsOrgPage`);
        });
      }
      else {
        Swal.fire({
          title: "Failed!",
          text: "Failed to activate school!",
          icon: "error",
          timer: 2000, // Pop-up duration in milliseconds
          showConfirmButton: false, // No need for a confirmation button
        })
      }
    } catch (error) {
      console.error('Error activating school:', error);
      alert('Failed to activate school. Please try again.');
    }
  };

  /* const handleDateChange = (date) => {
    setSelectedDate(date); // `date` is a Date object returned by DatePicker
 
    if (date) {
     // const formattedDate = date.toISOString().split('T')[0]; // Convert Date to YYYY-MM-DD format
     const formattedDate = date.toLocaleDateString('en-CA');        
      const filtered = schools.filter((school) => {
        // Compare the school's created_date with the formatted selected date
        return school.cdate === formattedDate;
      });
      setFilteredSchools(filtered); // Update the filtered schools state
    } else {
      setFilteredSchools(schools); // If no date is selected, show all schools
    }
  }; */

  const handleDateChange = (date) => {
    setSelectedDate(date);

    if (date) {
      const formattedDate = date.toLocaleDateString("en-CA"); // YYYY-MM-DD

      const filtered = schools.filter((school) => {
        if (!school.cdate) return false;

        const dbDate = school.cdate.split(" ")[0]; // extract YYYY-MM-DD
        return dbDate === formattedDate;
      });

      setFilteredSchools(filtered);
    } else {
      setFilteredSchools(schools);
    }
  };

  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchTerm(value);

    const filtered = schools.filter((school) => {
      return (
        school.school_name?.toLowerCase().includes(value) ||
        school.phone?.toLowerCase().includes(value) ||
        school.email_id?.toLowerCase().includes(value) ||
        school.state?.toLowerCase().includes(value) ||
        school.city?.toLowerCase().includes(value) ||
        `${school.f_name} ${school.l_name}`.toLowerCase().includes(value)
      );
    });

    setFilteredSchools(filtered);
  };


  const handleDelete = async (schoolId) => {

    // Show confirmation first
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "This will permanently delete the school!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    });

    if (!result.isConfirmed) return; // User clicked cancel

    try {
      // Make the API call to activate the school

      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}authormeetapi/get_cordinator_school_data.php?school_delete=${schoolId}`);
      const data = await response.json();
      if (data.success) {
        Swal.fire({
          title: "Delete School!",
          text: "School Deleted Successfully!.",
          icon: "success",
          timer: 2000, // Pop-up duration in milliseconds
          showConfirmButton: false, // No need for a confirmation button
        }).then(() => {
          // Reload the page after the notification
          window.location.reload();
        });
      }
      else {
        Swal.fire({
          title: "Failed!",
          text: "Failed to delete school!",
          icon: "error",
          timer: 2000, // Pop-up duration in milliseconds
          showConfirmButton: false, // No need for a confirmation button
        }).then(() => {
          // Reload the page after the notification
          window.location.reload();
        });
      }
    } catch (error) {
      console.error('Error activating school:', error);
      alert('Failed to activate school. Please try again.');
    }
  }

  // DataTable columns config
  const columns = [
    {
      name: 'Date Submitted',
      selector: row => row.created_date,
      sortable: true,
      minWidth: '120px',
    },
    {
      name: 'School/Organization Name',
      selector: row => row.school_name,
      sortable: true,
      minWidth: '200px',
      cell: row => (
        <Link to={`/NewSchoolsOrganizationDetailPage/${row.cordinator_id}`} className="text-primary">
          {row.school_name}
        </Link>
      ),
    },
    {
      name: 'State',
      selector: row => row.state,
      sortable: true,
      minWidth: '100px',
    },
    {
      name: 'City',
      selector: row => row.city,
      sortable: true,
      minWidth: '100px',
    },
    {
      name: 'Coordinator Name',
      selector: row => `${row.f_name} ${row.l_name}`,
      sortable: true,
      minWidth: '150px',
    },
    {
      name: 'Coordinator Email',
      selector: row => row.email_id,
      sortable: true,
      minWidth: '180px',
    },
    {
      name: 'Contact Number',
      selector: row => row.phone,
      sortable: true,
      minWidth: '130px',
    },
    {
      name: 'Status',
      minWidth: '100px',
      cell: row => (
        <button
          className={`${NewSchoolStyle.activateButton} btn btn-primary`}
          onClick={() => handleActivate(row.cordinator_id)}
        >
          <FaCloudArrowUp className='me-1' />Activate
        </button>
      ),
    },
    {
      name: 'Delete',
      minWidth: '80px',
      cell: row => (
        <Link to="" onClick={() => handleDelete(row.cordinator_id)}>
          <FiTrash2 className={NewSchoolStyle.trashIcons} />
        </Link>
      ),
    },
  ];

  // Data table custom styles
  const customStyles = {
    table: {
      style: {
        backgroundColor: '#FFFFFF',
        border: 'none',
        borderRadius: '0px',
        borderCollapse: 'collapse',
        borderSpacing: 0,
      },
    },
    headRow: {
      style: {
        backgroundColor: '#FFFFFF',
        borderBottom: 'none',
        minHeight: '40px',
        borderCollapse: 'collapse',
      },
    },
    headCells: {
      style: {
        font: 'normal normal 600 10px/16px Poppins',
        letterSpacing: '0px',
        color: '#707070',
        whiteSpace: 'normal',
        textAlign: 'left',
        padding: '10px 5px',
        border: '1px solid #dee2e6',
        borderCollapse: 'collapse',
        justifyContent: 'center',
        overflow: 'visible',
      },
    },
    rows: {
      style: {
        minHeight: '32px',
        fontSize: '10px',
        fontFamily: 'Poppins',
        fontWeight: 400,
        borderCollapse: 'collapse',
        color: '#707070',
        '&:not(:last-of-type)': {
          borderBottomStyle: 'none',
        },
      },
    },
    cells: {
      style: {
        font: 'normal normal 400 10px/24px Poppins',
        letterSpacing: '0px',
        color: '#707070',
        whiteSpace: 'nowrap',
        textAlign: 'left',
        padding: '5px',
        border: '1px solid #dee2e6',
        borderCollapse: 'collapse',
        justifyContent: 'center',
      },
    },
    pagination: {
      style: {
        borderTop: '1px solid #dee2e6',
        paddingTop: '15px',
        font: 'normal normal 400 12px/18px Poppins',
      },
      pageButtonsStyle: {
        color: '#1A58FF',
        fill: '#1A58FF',
      },
    },
  };

  return (
    <>
      <AdminHeader />
      <div className={NewSchoolStyle.newschoolsorganizationpage} style={{ minHeight: '700px' }}>
        <div className='container'>
          <div className='row mb-4'>
            <div className='col-xl-12'>
              <BackBar />
            </div>
          </div>
          <div className='row'>
            <div className='col-lg-3'>
              <AdminSideBar />
            </div>
            <div className="col-lg-9">
              <div className={`${NewSchoolStyle.nsotopData}`}>
                <div className="row">
                  <div className='col-lg-6'>
                    <div className='row'>
                      <div className='col-lg-4'>
                        <label className={`${NewSchoolStyle.nsolabel} form-label`}>Date Submitted:</label>
                      </div>
                      <div className='col-lg-6'>
                        <DatePicker selected={selectedDate} onChange={handleDateChange} format="MM/dd/yyyy" placeholder="MM/DD/YYYY" className={NewSchoolStyle.newdatePickerschol} />
                      </div>
                    </div>
                  </div>
                  <div className='col-lg-6'>
                    <div className='row'>
                      <div className='col-lg-5'> </div>
                      <div className='col-lg-2'>
                        <label className={`${NewSchoolStyle.nsolabel} form-label`}>Search:</label>
                      </div>
                      <div className='col-lg-5'>
                        <input type="text" className={`${NewSchoolStyle.nsoformControl} form-control`} value={searchTerm} onChange={handleSearch} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className={NewSchoolStyle.tableData}>
                <DataTable
                  columns={columns}
                  data={filteredSchools}
                  pagination
                  paginationPerPage={5}
                  paginationRowsPerPageOptions={[5, 10, 15, 20]}
                  highlightOnHover
                  striped
                  responsive
                  customStyles={customStyles}
                  progressPending={isLoading}
                  noDataComponent={<div style={{ padding: '10px', textAlign: 'center', color: '#707070', fontFamily: 'Poppins', fontSize: '12px' }}>No records found</div>}
                  sortIcon={<span style={{ paddingLeft: '5px' }}>▼</span>}
                  sortIconRight
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <AdminFooter />
    </>
  )
}